import { Trans } from "@lingui/react/macro";
import Link from "next/link";
import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface AnonymizedBadgeProps {
  /**
   * The main message to display in the tooltip.
   * Can be a string or a ReactNode (e.g., for <Trans> component).
   */
  tooltipMessage: string | React.ReactNode;
  /**
   * The URL for the "Learn more" link.
   */
  learnMoreUrl: string;
}

export function AnonymizedBadge({
  tooltipMessage,
  learnMoreUrl,
}: AnonymizedBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          className="px-2 py-px font-medium bg-gray-200 text-gray-700"
        >
          <Trans>Anonymized</Trans>
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        {tooltipMessage}
        <Link href={learnMoreUrl} target="_blank" className="underline ml-1">
          <Trans>Learn more</Trans>
        </Link>
      </TooltipContent>
    </Tooltip>
  );
}
